import { Component } from '@angular/core';

@Component({
  selector: 'ssg-prenote-history',
  templateUrl: './prenote-history.component.html',
  styleUrls: ['./prenote-history.component.less']
})
export class PrenoteHistoryComponent {
  constructor() { }
}
